import { ChromeTranslationActionTypes } from '../actions/types';

export default function (
  state: boolean = false,
  action: { type: ChromeTranslationActionTypes; payload: boolean },
): boolean {
  switch (action.type) {
    case ChromeTranslationActionTypes.ChangeIsChromeTranslated:
      return action.payload;
    default:
      return state;
  }
}
